import { Button, ButtonGroup, IconButton } from '@chakra-ui/react';
import { IconX } from '@tabler/icons';
import { PopoverFilter } from 'components/popover/PopoverFilter';

import { styleSelectedFilterButton } from '../constants/StylesFilterButtons';
import {
	IFilterBody,
	ISelectedFilterBody,
	ModulesType,
} from '../models/TableFilterModels';

interface ISelectedFilterItemProps {
	filter: IFilterBody;
	handleRemoveItem: (itemId: string) => void;
	setForm: React.Dispatch<React.SetStateAction<ISelectedFilterBody[]>>;
	form: ISelectedFilterBody[];
	applyFilters: (close: any) => void;
	module: ModulesType;
	selectedItems: string[];
	setSelectedItems: React.Dispatch<React.SetStateAction<string[]>>;
	getFromExternalAPI?: boolean;
	searchParams?: Object;
	localStorageValue: ISelectedFilterBody[];
	editable: boolean;
}

export const SelectedFilterItem = ({
	filter,
	handleRemoveItem,
	setForm,
	form,
	applyFilters,
	module,
	selectedItems,
	setSelectedItems,
	getFromExternalAPI = false,
	searchParams,
	localStorageValue,
	editable,
}: ISelectedFilterItemProps) => {
	const { column_name, dictionary_column_name, column_type } = filter;

	const renderFilterButton = (): string => {
		if (column_type !== 'string') {
			return dictionary_column_name;
		}

		const selectedFilter = form?.filter(
			item => item.column_name === column_name
		);

		const values: any =
			selectedFilter?.length > 0 ? selectedFilter[0].values : [];

		if (values.length === 0) {
			return dictionary_column_name;
		}

		if (values.length <= 2) {
			const formattedValues = values.map((value: string) =>
				value === '' ? 'Não Informado' : value
			);
			const valuesFilter = formattedValues?.join(', ');
			return `${dictionary_column_name}: ${valuesFilter}`;
		} else {
			return `${dictionary_column_name}: ${values.length} itens selecionados`;
		}
	};

	return (
		<PopoverFilter
			editable={editable}
			filter={filter}
			setForm={setForm}
			form={form}
			applyFilters={applyFilters}
			module={module}
			selectedItems={selectedItems}
			setSelectedItems={setSelectedItems}
			getFromExternalAPI={getFromExternalAPI}
			searchParams={searchParams}
			localStorageValue={localStorageValue}
		>
			<ButtonGroup
				isAttached
				mb={2}
				variant='outline'
				color={'easyBLUE.300'}
			>
				<Button {...styleSelectedFilterButton}>
					{renderFilterButton()}
				</Button>
				<IconButton
					data-test='button-remover_filtro'
					aria-label='Remover filtro'
					icon={
						<IconX
							width={'16px'}
							height={'16px'}
						/>
					}
					onClick={() => handleRemoveItem(column_name)}
					{...styleSelectedFilterButton}
				/>
			</ButtonGroup>
		</PopoverFilter>
	);
};
